import React, { useState } from 'react';
import '../../styles/Dashboard/SkillCard.css'

const SkillCard = () => {
  const [selectedSkill, setSelectedSkill] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  const skills = [
    { id: 'blog', label: 'Blog' },
    { id: 'socials', label: 'Socials' },
    { id: 'adsCopy', label: 'Ads copy' },
    { id: 'productCopy', label: 'Product copy' },
    { id: 'emailMarketing', label: 'Email marketing' }
  ];

  const handleSkillClick = (skillId) => {
    setSelectedSkill(skillId);
    
  };

  const handleEdit = () => {
    setIsEditing(true);
    
  };

  return (
    <div className="skills-editor-container">
      <div className="edit-section">
        <input 
          type="text" 
          className="form-control product-input" 
          placeholder="Product listing"
        
        />
        <button 
          className="btn btn-primary edit-btn rounded"
          onClick={handleEdit}
        >
          Edit
        </button>
      </div>

      <div className="skills-section">
        <div className="var80-header">
          <div className="icon-containers">
           <img src='/skillcard.svg'></img>
          </div>
          <h3 className='title'>See what <span className="highlight">VAR80</span> can help you with</h3>
        </div>

        <div className="skills-grid">
          {skills.map((skill) => (
            <button
              key={skill.id}
              className={`skill-btn ${selectedSkill === skill.id ? 'active' : ''}`}
              onClick={() => handleSkillClick(skill.id)}
            >
              {skill.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillCard;